const NOTE_MARKER = '^';

export function noteMarker(position: number): string {
  return NOTE_MARKER.repeat(Math.max(position, 1));
}

export function noteAnchorId(anchorPrefix: string, position: number): string {
  return `${anchorPrefix}-note-${position}`;
}
